import Footer from "../../../../components/footer";
import React, { useState, useEffect } from "react";
import "./redirectClient.css";
import { useNavigate } from "react-router-dom";
import HomeHeader from "../homeHeader";
import RedirectImage from "./assets/redirectImage.png";

const RedirectClient = () => {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  const handleRedirect = () => {
    navigate("/");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <HomeHeader isTitle={false} title={""} headerColor="header-white" />
      <div className="redirect-email-container">
        <div className="redirect-email-form-wrapper">
          <img
            src={RedirectImage}
            style={{ width: "210px", height: "130px" }}
            alt="Redirect"
          />
          <h2 className="redirect-email-heading">Password Updated!</h2>

          <p className="redirect-email-subtitle">
            Your password has been updated successfully!
          </p>
          <p className="redirect-email-subtitle">
            Redirecting to the login page in {secondsLeft} second
            {secondsLeft !== 1 && "s"}...
          </p>

          <button
            type="button"
            className="redirect-button"
            onClick={handleRedirect}
          >
            Go to Login Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RedirectClient;
